import MarketingLayout, { MarketingProse } from "../components/MarketingLayout";

const SECTIONS = [
  {
    h: "1. Agreement to terms",
    body: (
      <p>
        These Terms of Service ("Terms") are a binding agreement between you and ezItemizer Inc. ("ezItemizer", "we", "us"). By creating an account or using ezItemizer, you agree to these Terms. If you do not agree, do not use the service.
      </p>
    ),
  },
  {
    h: "2. The service",
    body: (
      <p>
        ezItemizer is a cloud-based inventory management tool for trailer-parts manufacturers and similar shops. We provide multi-user, role-based access, barcode scanning, low-stock alerts, audit logs and reports. Features vary by plan tier — see our pricing page for what's included.
      </p>
    ),
  },
  {
    h: "3. Your account",
    body: (
      <>
        <p>
          You are responsible for keeping your login credentials secure and for all activity that happens under your account. If you suspect unauthorized use, reset your password immediately and email{" "}
          <a href="mailto:info@ezitemizer.com" className="text-[#FF9800] underline">info@ezitemizer.com</a>.
        </p>
        <p>
          Account admins are responsible for managing the users in their organization, including granting and revoking access.
        </p>
      </>
    ),
  },
  {
    h: "4. Subscriptions, billing and refunds",
    body: (
      <ul className="list-disc pl-6 space-y-1.5">
        <li>All paid plans include a 14-day free trial. You will not be charged until the trial ends.</li>
        <li>Subscriptions auto-renew monthly. You can cancel at any time from the in-app Billing page; cancellation takes effect at the end of the current billing period.</li>
        <li>We do not offer pro-rated refunds for partial months. If we ever bill you in error, contact us and we will make it right.</li>
        <li>If a payment fails, we will retry and email the admin. After repeated failure your subscription will be marked past-due and account access may be limited until billing is restored.</li>
      </ul>
    ),
  },
  {
    h: "5. Acceptable use",
    body: (
      <>
        <p>You agree not to:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Use ezItemizer for illegal activity or to store illegal content.</li>
          <li>Attempt to reverse-engineer, decompile, or interfere with the service.</li>
          <li>Resell or sublicense the service without our written permission.</li>
          <li>Share your login with people outside your organization.</li>
          <li>Use ezItemizer to send unsolicited bulk email or to scrape data from third parties.</li>
        </ul>
      </>
    ),
  },
  {
    h: "6. Your data",
    body: (
      <p>
        You retain all rights to the inventory data you put into ezItemizer. We claim no ownership of it. We will only access your data to operate, support, secure or improve the service, or as required by law. You can export your data at any time from the Reports page.
      </p>
    ),
  },
  {
    h: "7. Service availability",
    body: (
      <p>
        We aim for high uptime but ezItemizer is provided "as is" without warranty of any kind. We may schedule maintenance windows or experience unplanned downtime. We are not liable for damages resulting from your inability to access the service.
      </p>
    ),
  },
  {
    h: "8. Limitation of liability",
    body: (
      <p>
        To the maximum extent permitted by law, ezItemizer's total liability to you for any claim arising out of these Terms is limited to the amount you paid us in the 12 months preceding the claim. We are not liable for any indirect, incidental, special, consequential or punitive damages.
      </p>
    ),
  },
  {
    h: "9. Termination",
    body: (
      <p>
        You may cancel your account at any time. We may suspend or terminate your account if you violate these Terms, fail to pay, or use the service in a way that puts other customers or our systems at risk. On termination, your subscription ends immediately and your data will be deleted as described in our Privacy Policy.
      </p>
    ),
  },
  {
    h: "10. Changes to these terms",
    body: (
      <p>
        We may update these Terms. If we make material changes, we will email account admins at least 14 days before the change takes effect. Continued use after a change means you accept the new Terms.
      </p>
    ),
  },
  {
    h: "11. Contact",
    body: (
      <p>
        Questions about these Terms? Email{" "}
        <a href="mailto:info@ezitemizer.com" className="text-[#FF9800] underline">info@ezitemizer.com</a>.
      </p>
    ),
  },
];

export default function Terms() {
  return (
    <MarketingLayout dataTestId="terms-page">
      <MarketingProse
        kicker="Legal"
        title="Terms of Service"
        lastUpdated="February 2026"
        dataTestId="terms-prose"
      >
        <p className="text-lg">
          The rules of the road for using ezItemizer. We've tried to keep these short and human-readable. If anything is unclear, just email us.
        </p>
        {SECTIONS.map((s) => (
          <section key={s.h}>
            <h2 className="font-display font-bold text-xl text-[#0F172A] mt-8 mb-3">{s.h}</h2>
            <div className="space-y-3">{s.body}</div>
          </section>
        ))}
      </MarketingProse>
    </MarketingLayout>
  );
}
